import { Link } from 'react-router-dom';

const facebookUrl = 'https://www.facebook.com/groups/themommymingle';

const quickLinks = [
  { label: 'Events', icon: 'ri-calendar-event-line', to: '/events', external: false },
  { label: 'Summer Camp Hub', icon: 'ri-compass-3-line', href: 'https://gwinnettcampguide.com', external: true },
  { label: 'What The Duck', icon: 'ri-duck-line', to: '/whattheduck', external: false },
  { label: 'Things To Do', icon: 'ri-map-pin-2-line', to: '/things-to-do', external: false },
  { label: 'Local Help', icon: 'ri-heart-2-line', to: '/local-resources', external: false },
  { label: 'Membership', icon: 'ri-vip-crown-line', to: '/membership', external: false },
];

export default function FinalCTA() {
  return (
    <section className="py-32 bg-gray-950">
      <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-20 text-center">
        {/* Tagline — second placement */}
        <p className="text-pink-400/70 text-xs font-bold tracking-[0.3em] uppercase mb-6">
          Mix &bull; Mingle &bull; Make Memories
        </p>

        <span className="text-xs font-bold tracking-widest uppercase text-pink-400 mb-6 block">
          You Don&apos;t Have to Do This Alone
        </span>
        <h2 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.05] mb-8 tracking-tight">
          Find your people.<br />Build your village.<br />
          <span className="text-pink-400">Make it easier.</span>
        </h2>
        <p className="text-white/60 text-lg mb-12 leading-relaxed max-w-xl mx-auto">
          Join 1,000+ local moms finding things to do, building friendships, and making life easier.
        </p>
        <a
          href={facebookUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 px-10 py-5 bg-pink-600 text-white rounded-full text-base font-bold hover:bg-pink-500 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
        >
          Join The Mommy Mingle
          <i className="ri-arrow-right-line text-lg"></i>
        </a>
        <p className="text-white/30 text-xs mt-6 font-medium tracking-wide">
          Always free. No credit card. No pressure.
        </p>

        {/* Quick navigation links */}
        <div className="mt-16 pt-10 border-t border-white/10">
          <p className="text-white/30 text-xs font-semibold tracking-widest uppercase mb-6">Explore The Platform</p>
          <div className="flex flex-wrap justify-center gap-3">
            {quickLinks.map((link) =>
              link.external ? (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 rounded-full text-white/60 hover:text-white text-xs font-semibold transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className={`${link.icon} text-sm`}></i>
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.label}
                  to={link.to ?? '/'}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 rounded-full text-white/60 hover:text-white text-xs font-semibold transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className={`${link.icon} text-sm`}></i>
                  {link.label}
                </Link>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
